import { DrawerBody, DrawerFooter, SubmitButton } from "@dgs/core";
import { Formik, useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ICompanyFormState } from "../../shared/types";
import { CompanyDrawerFormFields } from "../CompanyDrawerFormFields";
import { CreateCompanyStepForm, DrawerForm, FormActions, useCompanyFormValidation } from "./Form";

export type MasterDataFormValues = ICompanyFormState;
export const emptyMasterDataFormValues: MasterDataFormValues = {
	name: "",
	parent: null,
	tenants: [],
	pivotValues: {},
};

interface MasterDataFormFieldsProps {
	setIsDirty?: (dirty: boolean) => void;
}

const MasterDataFormFields: FC<MasterDataFormFieldsProps> = ({ setIsDirty }) => {
	const { dirty } = useFormikContext();

	useEffect(() => {
		setIsDirty && setIsDirty(dirty);
	}, [dirty, setIsDirty]);

	return <CompanyDrawerFormFields />;
};

interface Props extends CreateCompanyStepForm<MasterDataFormValues> {
	setIsDirty?: (dirty: boolean) => void;
}

export const MasterDataForm: FC<Props> = ({ setIsDirty, initialValues, onSubmit }) => {
	const { t } = useTranslation();
	const validate = useCompanyFormValidation();

	return (
		<Formik initialValues={initialValues} onSubmit={onSubmit} validate={validate} validateOnChange={false}>
			<DrawerForm>
				<DrawerBody>
					<MasterDataFormFields setIsDirty={setIsDirty} />
				</DrawerBody>
				<DrawerFooter>
					<span />
					<FormActions>
						<SubmitButton>{t("Next")}</SubmitButton>
					</FormActions>
				</DrawerFooter>
			</DrawerForm>
		</Formik>
	);
};
